import { defineStore } from 'pinia';
import { ref, Ref } from 'vue';
import {
  ProductOptionCategoryObject,
  ProductOptionCategoryProductOptionObject,
} from '../types/joostconnector';
import _ from 'lodash';

export const useExtraOptionsStore = defineStore(
  `extra-options-${window.product.sku}`,
  () => {
    const productOptionsCategories: Ref<ProductOptionCategoryObject[]> = ref(
      []
    );
    const selectedOptions: Ref<
      Record<number, ProductOptionCategoryProductOptionObject>
    > = ref([]);

    function toggleActiveProductOption(
      productOption: ProductOptionCategoryProductOptionObject,
      productOptionCategory: ProductOptionCategoryObject,
      isSelectedByUser: boolean = false
    ): void {
      // Remove from selected list if option is already selected
      if (
        isSelectedByUser &&
        selectedOptions.value[productOptionCategory.id]?.id === productOption.id
      ) {
        delete selectedOptions.value[productOptionCategory.id];
        return;
      }

      // Select option if it isn't selected yet
      selectedOptions.value[productOptionCategory.id] = productOption;
    }

    function selectDefaultProductOptions(): void {
      _.each(productOptionsCategories.value, productOptionCategory => {
        const currentSelectedProductOption =
          selectedOptions.value[productOptionCategory.id];
        let productOption = _.find(
          productOptionCategory?.productOptions,
          'isDefault'
        );

        if (currentSelectedProductOption) {
          // Overwrite default product option with the one matched on name from the available product options (because some data, e.g. the price can be different)
          // If for any reason no product option with the same name exist, fallback on the default
          productOption =
            _.find(
              productOptionCategory?.productOptions,
              productOption =>
                productOption.id === currentSelectedProductOption.id
            ) ?? productOption;
        }

        if (productOption) {
          toggleActiveProductOption(productOption, productOptionCategory);
        }
      });

      // Remove unwanted undefined values
      selectedOptions.value = _.omitBy(selectedOptions.value, _.isNil);

      const categoryIds = _.map(
        productOptionsCategories.value,
        'id'
      ) as number[];
      const currentCategoryIdsAsString = _.keys(
        selectedOptions.value
      ) as string[];
      const currentCategoryIds = _.map(
        currentCategoryIdsAsString,
        (id: string) => Number(id)
      );
      const oldCategoryIds = _.difference(currentCategoryIds, categoryIds);

      selectedOptions.value = _.omit(selectedOptions.value, oldCategoryIds);
    }

    return {
      productOptionsCategories,
      selectedOptions,
      toggleActiveProductOption,
      selectDefaultProductOptions,
    };
  },
  { persist: { paths: ['selectedOptions'] } }
);
